import React from 'react';
import { Body } from '@hover/blueprint';
import { Link as GatsbyLink } from 'gatsby';

const HeroContent: React.FC = () => (
  <>
    <Body
      textTransform="uppercase"
      isBold
      size={300}
      color="brandNavy.300"
      letterSpacing="0.1rem"
    >
      Last Revised: October 27, 2022
    </Body>
    <Body
      as={GatsbyLink}
      to="/terms-of-use/"
      isSemiBold
      size={300}
      color="primary.600"
    >
      Access new HOVER terms of use
    </Body>
  </>
);

export default HeroContent;
